import ViewInvoiceModal from 'pages/lookupInvoice/components/ViewInvoiceModal';

export const PublicModalType = {
  INVOICE_VIEWER: 'INVOICE_VIEWER'
};

export const PublicModals = {
  [PublicModalType.INVOICE_VIEWER]: ViewInvoiceModal
};
